import JobSearchList, { JobSearchListProps } from './JobSearchList.component';

export type JobSearchListType = JobSearchListProps;

export default JobSearchList;
